import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {signupFormList_template} from "../components/templates/signupFormList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class signup_form extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected signupFormList: signupFormList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.signupFormList = new signupFormList_template("signupFormList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Signup Forms List");
        return [this.signupFormList.build()];
    }

    protected getModuleName(): string {
        return "signup_form";
    }

    fillPage() {
        this.getSignupFormData();
    }

    protected getSignupFormData() {
        this.loadingIn(this.signupFormList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.signupFormList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/signupForm/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.ongetSignupFormDataReturn;
        this.XHRHdl.execute();
    }

    protected ongetSignupFormDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let signupForms = responseParsed.data;


                obj.viewModel.signupFormList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.signupFormList.setResultInfo(totalCount, totalPage, execTime)

                obj.signupFormList.setSignupForms(signupForms, obj.getBrandId())

            });
            obj.loadingOut(obj.signupFormList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected signupFormsListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getSignupFormData()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getSignupFormData();
    }

    protected filterSimpleOnChange(){

        this.viewModel.signupFormList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.signupFormList.builtTemplate.children.namedItem("list-results"));

        let signupFormReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/signupForm/get/';
        let signupFormReq_params: Array<Array<string>> = [];
        signupFormReq_params.push(["data", ko.toJSON(this.signupFormList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(signupFormReq_url,signupFormReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.signupFormList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

        // set signupForms list
        let signupForms = responseParsed.data;
        this.signupFormList.setSignupForms(signupForms, this.getBrandId());

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.signupFormList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.viewModel.signupFormList.pagination.itemCount(responseParsed.totalCount);
    }

    protected viewSignupForm(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/signup-forms/view/' + id + '/')
    }

    protected addSignupForm() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/signup-forms/add/')
    }

    protected deleteSignupForm(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/signupForm/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.signupFormList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Signup Form" + "<strong>" + data.label + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getSignupFormData()
                })

                obj.loadingOut(obj.signupFormList.builtTemplate.children.namedItem("list-results"));
            }
        });
        XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}


// WEBPACK FOOTER //
// ./js/modules/signup_form.ts